/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(async function () {
  const jsonElement = $("#custom-product-configurator-json");
  const fullData = JSON.parse(jsonElement.html());
  const jsonMetafieldsElement = $(
    "#custom-product-configurator-metafields-json"
  );
  const productMetafields = JSON.parse(jsonMetafieldsElement.html());

  const apiEndpoint = "https://k42xhfp7p7.execute-api.us-west-2.amazonaws.com/Prod";

  const configuratorContainer = $("#custom-configurator-container");

  const productCode = configuratorContainer.attr("data-product-code");

  let fullWeightData = await $.get(
    window.theme.assets.roman_product_weight
  ).promise();
  let fullOptionsData = await $.get(
    window.theme.assets.roman_product_options
  ).promise();
  fullWeightData = fullWeightData.data;

  let weightData;
  let optionsData;

  fullWeightData.forEach(function (element) {
    if (element.Line == productCode) {
      weightData = element;
    }
  });

  fullOptionsData.forEach(function (element) {
    if (element.Code == productCode) {
      optionsData = element;
    }
  });


  const lowercaseKeys = (obj) =>
    Object.keys(obj).reduce((acc, key) => {
      acc[key.toLowerCase()] = obj[key];
      return acc;
    }, {});

  const optionsDataLowerKeys = lowercaseKeys(optionsData);
  const weightOptionsLowerKeys = lowercaseKeys(weightData);

  const widthSelect = $("#select-width-id");
  const lengthSelect = $("#select-length-id");
  
  const selectWidthSub = $("#select-sub-width-id");
  const selectLengthSub = $("#select-sub-length-id");

  let minLength = 12;
  let maxLength = 120;
  let lengthValue = 12;

  let minWidth = 12;
  let maxWidth = 48;
  let widthValue = 12;

  const orderDetailsBtn = $("#custom-configurator-expand-order-details");
  const orderDetailsComponent = $("#custom-configurator-order-details");

  orderDetailsBtn.click(function () {
    orderDetailsComponent.fadeIn();
  });

  const renderOrderSummary = () => {
    let selectedDesign = $("#custom-design-selector").attr('data-image-select-value');
    let selectedMount = $("#custom-mount-selector").attr('data-image-select-value');
    let selectedLining = $("#custom-lining-selector").attr('data-image-select-value');
    let selectedCord = $("#custom-cord-selector").attr('data-image-select-value');
    let selectedLift = $("#custom-lift-selector").attr('data-image-select-value');
    const selectedDesignModal = $('.custom-configurator-design');
    const selectedMountModal = $('.custom-configurator-mount');
    const selectedLiningModal = $('.custom-configurator-lining');
    const selectedCordModal = $('.custom-configurator-cord');
    const selectedLiftModal = $('.custom-configurator-lift');
    const selectedWidthModal = $('.custom-configurator-width');
    const selectedLengthModal = $('.custom-configurator-length');

    orderDetailsComponent.find(".order-detail__design").html(selectedDesign);
    orderDetailsComponent.find(".order-detail__mount").html(selectedMount);
    orderDetailsComponent.find(".order-detail__cord").html(selectedCord);
    orderDetailsComponent.find(".order-detail__lift").html(selectedLift);
    orderDetailsComponent.find(".order-detail__lining").html(selectedLining);

    orderDetailsComponent
      .find(".order-detail__width")
      .html(`${widthValue}" ${selectWidthSub.val()}`);
    orderDetailsComponent
      .find(".order-detail__length")
      .html(`${lengthValue}" ${selectLengthSub.val()}`);

    selectedDesignModal.html(selectedDesign);
    selectedMountModal.html(selectedMount);
    selectedLiningModal.html(selectedLining);
    selectedCordModal.html(selectedCord);
    selectedLiftModal.html(selectedLift);
    selectedWidthModal.html(`${widthValue}" ${selectWidthSub.val()}"`);
    selectedLengthModal.html(`${lengthValue}" ${selectLengthSub.val()}"`);
  };

  renderOrderSummary()

  const switchMountInfo = () => {
    const selectedMount = $('#custom-mount-selector').attr('data-image-select-value')

    if (selectedMount == 'Inside') {
      $('#main-depth').show()
      $('#js-inside-mount-size-info').show()
      $('#js-outside-mount-size-info').hide()
      $('.size').addClass('disable')
      $("input#confirm-depth").click(function(){
        if ($('input#confirm-depth').is(':checked')) {
          $('.size').removeClass('disable');
        } else {
          $('.size').addClass('disable');
        }
      });
      $(".form__width").click(function(){
        if ($('input#confirm-depth').is(':checked')) {
          $('.size').removeClass('disable');
        }
      });
    } else {
      $('#main-depth').hide()
      $('#js-inside-mount-size-info').hide()
      $('#js-outside-mount-size-info').show()
      $('.size').removeClass('disable')
    }
  }

  const manageAvailability = () => {
    const liningOptions = $("#custom-lining-selector").children();
    const allOptions = $(".custom-managable-options");

    allOptions.each(function (_, el) {
      const headerName = $(el).attr("data-image-select-item").toLowerCase();
      if (optionsDataLowerKeys[headerName] == "FALSE") {
        $(el).hide();
        $(el).attr("data-is-active", "false");
      } else {
        $(el).attr("data-is-active", "true");
      }
    });

    for (let index = 0; index < liningOptions.length; index++) {
      const element = liningOptions[index];
      if ($(element).attr("data-is-active") == "true") {
        const valueSelected = $(element).attr("data-image-select-item");
        const priceSelected = $(element).attr("data-image-select-item-price");
        $(element).parent().attr("data-image-select-value", valueSelected);
        $(element).parent().attr("data-image-select-value-price", priceSelected);
        $(element)
          .parent()
          .prev()
          .children(".custom-configurator-option-title-value")
          .html(valueSelected);
        $(element).addClass("custom-configurator-image-select-item-active");
        break;
      }
    }

    switchMountInfo()
  };

  const getWeightPriceValue = (lineOption) => {
    return weightOptionsLowerKeys[lineOption];
  };

  const calculatePrice = () => {
    const pricePerYard = productMetafields.price_per_yard;
    const pricePerPound = 11.5;
    const cusDiscountVal = productMetafields.custom_product_discount;
    
    const selectSubLength = document.querySelector('#select-sub-length-id');
    const outputLength = selectSubLength.options[selectSubLength.selectedIndex].getAttribute('data-sub-length-value');

    // if(outputLength = "0"){
    //   outputLength = 0;
    // } else if (outputLength = "1/8"){
    //   outputLength = 0.125;
    // }
    
    const liningBasePrice = $("#custom-lining-selector").attr(
      "data-image-select-value-price"
    );

    const liftBasePrice = $("#custom-lift-selector").attr(
      "data-image-select-value-price"
    );

    const designBasePrice = $("#custom-design-selector").attr(
      "data-image-select-value-price"
    );

    const liningOption = $("#custom-lining-selector")
    .attr("data-image-select-value")
    .toLowerCase();

    const weightPrice = getWeightPriceValue (liningOption)
    const widthForCalculation = 1

    const totalYards = ((30 + parseFloat(lengthValue) + parseFloat(outputLength)) / 36) * parseInt(widthForCalculation);

    const fabricCost =  totalYards * pricePerYard;
    const fabricationCost = liftBasePrice
    const totalWeight = weightPrice * totalYards + 2.5;
    const shippingCost = totalWeight * pricePerPound;
    const liningCost = totalYards * liningBasePrice;
    const designCost = designBasePrice;
    const additionalCost = parseFloat(fabricationCost) + 
      parseFloat(designBasePrice) +
      parseFloat(fabricCost) + 
      parseFloat(liningCost) + 
      parseFloat(shippingCost);

    const extraCharge = 10;

    console.log(additionalCost);

    let total = parseFloat(fabricCost) +
    parseFloat(liningCost) +
    parseFloat(fabricationCost) +
    parseFloat(shippingCost) + 
    parseFloat(designCost) +
    parseFloat(additionalCost) +
    extraCharge;

    // Discount Value Variable (You can edit it the discount will works in percentage)
    const percentageValue = parseInt(cusDiscountVal) || 0;
    // End Comment

    const discountValue = total/100*percentageValue;
    const discountedTotal = total - discountValue;

    $(".regular-price").each(function (_, el) {
      $(el).html(`$${total.toFixed(2)}`);
    });

    $(".custom-configurator-price").each(function (_, el) {
      $(el).html(`$${discountedTotal.toFixed(2)}`);
    });

    $(".save-custom-configurator-price").each(function (_, el) {
      $(el).html(`Save $${discountedTotal.toFixed(2)}`);
    });

    $(".custom-configurator-price-double").each(function (_, el) {
      $(el).html(`$${(discountedTotal * 2).toFixed(2)}`);
    });

    $("#custom-title-price").each(function (_, el) {
      $(el).html(`$${discountedTotal.toFixed(2)}`);
    });

      $('.roman-pricePerYard').html(pricePerYard);
      $('.roman-pricePerPound').html(pricePerPound);
      $('.roman-liningBasePrice').html(liningBasePrice);
      $('.roman-liftBasePrice').html(liftBasePrice);
      $('.roman-liningOption').html(liningOption);
      $('.roman-weightPrice').html(weightPrice);
      $('.roman-widthForCalculation').html(widthForCalculation);
      $('.roman-totalYards').html(totalYards);
      $('.roman-fabricCost').html(fabricCost);
      $('.roman-fabricationCost').html(fabricationCost);
      $('.roman-totalWeight').html(totalWeight);
      $('.roman-shippingCost').html(shippingCost);
      $('.roman-liningCost').html(liningCost);
      $('.roman-total').html(total);

    switchMountInfo()

    renderOrderSummary()

    const totalPriceModal = $('.custom-configurator-total-price');
    totalPriceModal.html(discountedTotal.toFixed(2));
    return discountedTotal;
  };

  // Setting up size selects
  const generateDataForSizes = (min, max) => {
    const arrayOfOptions = [];
    for (let i = min; i <= max; i++) {
      arrayOfOptions.push(i);
    }

    return arrayOfOptions;
  };

  const createSelectOptions = (data, selectId) => {
    const selectElement = $(`#${selectId}`);
    selectElement.empty();
    data.forEach((option, index) => {
      let singleElement = `<option value="${option}">${option}</option>`;
      if (index == 0) {
        singleElement = `<option value="${option}" selected="selected">${option}</option>`;
      }
      selectElement.append(singleElement);
    });
  };

  // Managing the lining information
  const manageInfoForLining = () => {
    const liningSelected = $("#custom-lining-selector").attr(
      "data-image-select-value"
    );
    const liningInfoBoxes = $(".custom-configurator-lining-info-box");
    liningInfoBoxes.each(function (_, el) {
      $(el).hide();
      if ($(el).attr("data-image-select-item") == liningSelected) {
        $(el).show();
      }
    });
  };

  // Update swatch media
  const productMedia = $('[data-product-slideshow]');
  const productThumbs = $('[data-thumb-item]');
  // const selectedColorModal = $('.custom-configurator-color');
  const updateSwatchMedia = () => {
    var selectedDesign = $("[data-image-select-name='Design']").attr('data-image-select-value');
    // var selectedFabric = $("[data-image-select-name='Fabric']").attr('data-image-select-value');
    var selectedMedia = productMedia.find(`[data-swatch-media="${selectedDesign}"]`);
    var selectedThumb = productThumbs.find(`img[alt="${selectedDesign}"]`);

    if (selectedMedia.length) {
      productMedia.find('.product__slide').each(function (__, el) {
        $(el).addClass('media--hidden');
        $(el).removeClass('is-selected');
      });
      productThumbs.each(function (__, el) { // mobile
        $(el).removeClass('is-active');
      })
      selectedMedia.removeClass('media--hidden');
      selectedMedia.addClass('is-selected');
      selectedThumb.parents('[data-thumb-item]').addClass('is-active'); // mobile
    };
    // selectedColorModal.html(selectedFabric);
  }


  const widthOptions = generateDataForSizes(minWidth, maxWidth);
  const lengthOptions = generateDataForSizes(minLength, maxLength);

  createSelectOptions(widthOptions, "select-width-id");
  createSelectOptions(lengthOptions, "select-length-id");

  // Size Selects config
  widthSelect.change(function () {
    widthValue = widthSelect.val();
  });

  lengthSelect.change(function () {
    lengthValue = lengthSelect.val();
  });

  // Size selectors
  const selectElements = $(".option-selector");
  const sizeValueText = $("#custom-configurator-option-title-value-size");

  selectElements.each((_, element) => {
    if (_ == 0) {
      widthValue = $("#select-width-id").val();
      widthSubValue = $('#select-sub-width-id').val();
      lengthValue = $("#select-length-id").val();
      lengthSubValue = $("#select-sub-length-id").val();
      sizeValueText.html(`${widthValue}" ${widthSubValue} W X ${lengthValue}" ${lengthSubValue} L`);
    }
    $(element).change(() => {
      widthValue = $("#select-width-id").val();
      widthSubValue = $('#select-sub-width-id').val();
      lengthValue = $("#select-length-id").val();
      lengthSubValue = $("#select-sub-length-id").val();
      sizeValueText.html(`${widthValue}" ${widthSubValue} W X ${lengthValue}" ${lengthSubValue} L`);
      calculatePrice();
    });
  });

  // Setting up slider
  $(document).ready(function () {});

  // Image selectors
  const imageSelectorElements = $(".custom-configurator-image-select");

  imageSelectorElements.each(function (_, imgSelectorEl) {
    const imageSelectsItems = $(imgSelectorEl).children(
      ".custom-configurator-image-select-item"
    );
    imageSelectsItems.each(function (__, imgSelectorItemEl) {
      $(imgSelectorItemEl).click(function () {

        imageSelectsItems.each(function (___, el) {
          $(el).removeClass("custom-configurator-image-select-item-active");
        });
        $(this).addClass("custom-configurator-image-select-item-active");
        const valueSelected = $(this).attr("data-image-select-item");
        const priceSelected = $(this).attr("data-image-select-item-price");
        const typeSelected = $(this).parent().attr('data-image-select-name');

        $(this).parent().attr("data-image-select-value", valueSelected);
        $(this).parent().attr("data-image-select-value-price", priceSelected);

        $(this)
          .parent()
          .prev()
          .children(".custom-configurator-option-title-value")
          .html(valueSelected);
        calculatePrice();
        manageInfoForLining();

        if (typeSelected === 'Design' || typeSelected === 'Fabric') {
          updateSwatchMedia();
        }
      });
    });
  });

  manageAvailability();
  manageInfoForLining();


  // QUANTITY CONTROLLER
  const quantityInput = $("#custom-configurator-qty-value");
  const quantityAdd = $("#custom-configurator-qty-btn-increase");
  const quantityReduce = $("#custom-configurator-qty-btn-reduce");
  const quantityOptionPlus = $("[data-configurator-qty-option-plus]");
  let quantityValueModal = $('.custom-configurator-qty');

  quantityValueModal.html(quantityInput.val());

  quantityOptionPlus.click(function () {
    $("#custom-configurator-qty-popout").addClass("popout-container--alt");
  });

  let currentValue = parseInt(quantityInput.val());
  
  quantityInput.change(function () {
    const quantityValue = $(this).val();
    if (quantityValue < 1) {
      $(this).val(1);
    }
    currentValue = parseInt(quantityInput.val());
    quantityValueModal.html(currentValue);
    updateSubtotal(currentValue);
  });

  const updateSubtotal = (qty) => {
    const singlePrice = parseFloat($('.custom-configurator-single-price').html().replace('$', ''));
    const totalPrice = singlePrice * qty;
    $('.custom-configurator-price-subtotal').html(`$${totalPrice.toFixed(2)}`);
  };

  quantityAdd.click(function () {
    currentValue++;
    quantityInput.val(currentValue);
    updateSubtotal(currentValue);
  });

  quantityReduce.click(function () {
    if (quantityInput.val() <= 1) {
      quantityInput.val(1);
    } else {
      currentValue--;
      quantityInput.val(currentValue);
      updateSubtotal(currentValue);
    }
  });

  // ADD TO CART
  const customConfiguratorAddToCart = $("#custom-configurator-submit");
  customConfiguratorAddToCart.click(function () {

    let customSKU = fullData.variants.filter((variant) => variant.title === "Default Title");

    if (customSKU.length !== 0) {
      customSKU = customSKU[0].sku;
    }

    let design = $(".custom-configurator-design").text();

    if(design === "Casual") {
      customSKU = customSKU.replace("-CUS", "-CAS");
    } else if (design === "Relaxed") {
      customSKU = customSKU.replace("-CUS", "-RLX");
    }

    customConfiguratorAddToCart.addClass("is-loading");
    const title = fullData.title;
    const productImage = fullData.featured_image;
    const qty = parseFloat(quantityInput.val());
    const sku = customSKU;

    generateProductAndAddToCart(title, qty, `http:${productImage}`, sku);
    closeModal();
  });

  const generateProductAndAddToCart = async (title, quantity, image, sku) => {
    let price = calculatePrice();
    let productInfo = {
      title: title,
      price: price,
      quantity: quantity,
      image: image,
      sku: sku,
    };

    const res = await $.post(`${apiEndpoint}/configurator/add-custom-product`, JSON.stringify(productInfo)).promise();
    
    let properties = {};

    console.log('ProductInfo: ', productInfo);
    console.log('Res: ', res);
    
    $(".custom-configurator-image-select").each(function (_, el) {
      let elName = $(el).attr("data-image-select-name");
      let elValue = $(el).attr("data-image-select-value");
      properties[elName] = elValue;
    });

    properties["size"] = `${widthValue}" ${selectWidthSub.val()}" W X ${lengthValue}" ${selectLengthSub.val()}" L`;
    properties["Length"] = `${lengthValue}" ${selectLengthSub.val()}`;
    properties["Width"] = `${widthValue}" ${selectWidthSub.val()}`;
    // const WindowDescription = $("#window-description").val();
    // properties["Window Description"] = WindowDescription;

    let formData = {
      items: [
        {
          id: res.product.variants[0].id,
          quantity: parseInt(quantity),
          properties,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        initCartEvent();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const initCartEvent = () => {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:cart:init", {
        bubbles: true,
        detail: {
          button: customConfiguratorAddToCart,
        },
      })
    );
  };

  calculatePrice();

  // const configuratorSubmit = $('#custom-configurator-submit');
  // $('input[type="checkbox"]').change(function () {
  //   if (this.checked) {
  //     configuratorSubmit.removeClass('variant--unavailable');
  //     configuratorSubmit.prop("disabled", false);
  //   } else {
  //     configuratorSubmit.addClass('variant--unavailable');
  //     configuratorSubmit.prop("disabled", true);
  //   }
  // });

  const closeModal = () => {
    setTimeout(() => {
      $('.product-modal').css({
        'opacity': '0',
        'display': 'none'
      });
    }, 3000);
  };
})();